module.exports = __webpack_public_path__ + "img/machine-learning.9f10cd50.png";